import request, { REQUEST_METHODS } from '@api/Request';
import { NonPcnEndpoints } from './config';
import { AddNonPcnRequest, AddNonPcnResponse, GetNonPcnResponse, UpdateNonPcnResponse } from './types';

export default class NonPcnService {
  public static readonly addNonPcn = (data: AddNonPcnRequest): Promise<AddNonPcnResponse> =>
    request({
      url: NonPcnEndpoints.addNonPcn(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly updateNonPcn = (data: any): Promise<UpdateNonPcnResponse> =>
    request({
      url: NonPcnEndpoints.updateNonPcn(),
      method: REQUEST_METHODS.PUT,
      data,
    });
  public static readonly getNonPcn = (
    projectID: number,
    requestID: number,
    version: number
  ): Promise<GetNonPcnResponse> =>
    request({
      url: NonPcnEndpoints.getNonPcn(),
      method: REQUEST_METHODS.GET,
      params: { projectID, requestID, version },
    });
}
